module.exports = __webpack_public_path__ + "fonts/nunito-sans-v11-latin-600.50ad2af8.ttf";